import type {ReactElement} from 'react';
import React from 'react';
import type {PublishingCreateEventWebpagePanelProps} from '@Panels/poster-publishing-options-panel/components/publishing-create-event-webpage-panel/publishing-create-event-webpage-panel.types';
import {noop} from '@Utils/general.util';
import {DisplayType} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import {useAppDispatch} from '@/hooks';
import type {DesignPageSelectorOpts} from '@Panels/design-page-selector/design-page-selector.types';
import {PageSelectorSize, SelectionLimitBehavior} from '@Panels/design-page-selector/design-page-selector.types';
import {handleBackButtonClick} from '@Panels/poster-publishing-options-panel/poster-publishing-options-slice';
import {DesignPageSelector} from '@Panels/design-page-selector/design-page-selector';
import {getEventWizardURLWithDesignPrefill} from '@Libraries/events.library';
import {MediaTypes} from '@Components/event-wizard/event-wizard-image-video/event-wizard-image-video.types';

export function PublishingCreateEventWebpagePanel({
  posterHashedId,
  onSubmit = noop,
  onClose = noop,
  className: propsClassName = '',
  displayType = DisplayType.DROPDOWN,
  ...props
}: PublishingCreateEventWebpagePanelProps): ReactElement | null {
  const dispatch = useAppDispatch();
  const PAGE_LIMIT = 1;

  const onSubmitPage = (pageHashedIds: string[]): void => {
    const pageIdToUse = pageHashedIds[0];
    onSubmit(pageIdToUse ? [pageIdToUse] : []);
    // eslint-disable-next-line react-compiler/react-compiler
    window.location.href = getEventWizardURLWithDesignPrefill(posterHashedId, MediaTypes.MY_DESIGNS, pageIdToUse);
  };

  const getSelectionOptsForPanel = (): DesignPageSelectorOpts => {
    return {
      selectionLimitBehavior: SelectionLimitBehavior.DESELECT_FIRST,
      pageLimit: PAGE_LIMIT,
    } as DesignPageSelectorOpts;
  };

  const getClassesForDesignPageSelector = (): string => {
    let classNameToUse = propsClassName;

    if (displayType === DisplayType.DROPDOWN) {
      classNameToUse += ' spacing-p-t-0';
    }

    return classNameToUse;
  };

  const handleBackButton = (): void => {
    dispatch(handleBackButtonClick());
  };

  return (
    <DesignPageSelector
      {...props}
      className={getClassesForDesignPageSelector()}
      posterId={posterHashedId}
      onSubmit={onSubmitPage}
      selectionOpts={getSelectionOptsForPanel()}
      ctaText={window.i18next.t('pmwjs_publish')}
      headerTitle={window.i18next.t('pmwjs_select_a_page')}
      showBackButton
      onBackButton={handleBackButton}
      showCloseButton={displayType === DisplayType.MODAL}
      onClose={onClose}
      size={displayType === DisplayType.DROPDOWN ? PageSelectorSize.SMALL : PageSelectorSize.MEDIUM}
    />
  );
}
